import React from 'react'
import CareerHero from './CareerHero'
import CareerText from './CareerText'
import CareerBody from './CareerBody'

const Career = () => {
  return (
    <div>
      <CareerHero/>
      <CareerText/>
      <CareerBody/>
    </div>
  )
}

export default Career
